module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome-card pane"
  }, [_c('div', {
    staticClass: "features"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.tbcMode) ? _c('div', {
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "img desk"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("一键上传，碎片知识快速沉淀")]), _vm._v(" "), _vm._m(2)]) : _c('div', {
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "img wechat"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("扫码阅读，轻松分享传播")]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [(_vm.showCreateProject) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._v("开始上传")]) : _c('span', [_vm._v(_vm._s(_vm.$t('noProject')))])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "img light"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("最简单的 H5 工具")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_c('p', [_vm._v("一键 PPT 转换 H5，零门槛上手")]), _vm._v(" "), _c('p', [_vm._v("完美还原动画、音视频、交互")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "img doc"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("支持答题 & 录音")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_c('p', [_vm._v("所见即所得制作答题、表单及录音")]), _vm._v(" "), _c('p', [_vm._v("轻松搞定专业级功能")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub"
  }, [_c('p', [_vm._v("支持将制作好的微课一键同步上传至课程和资料")]), _vm._v(" "), _c('p', [_vm._v("快速沉淀业务碎片化知识，搭建内部微课体系")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub"
  }, [_c('p', [_vm._v("微信扫码查看 H5，随心分享")]), _vm._v(" "), _c('p', [_vm._v("营销策划、微课、产品介绍、工作汇报，统统搞定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c712ac5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/welcome.vue
// module id = 946
// module chunks = 3